module.exports = __webpack_public_path__ + "media/icons/figures-b2d54a05.png";